module.exports = __webpack_public_path__ + "img/img-725559.png";